import { render, staticRenderFns } from "./DocumentosAsociadosNewOrEdit.vue?vue&type=template&id=41e570da&scoped=true&"
import script from "./DocumentosAsociadosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentosAsociadosNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosAsociadosNewOrEdit.vue?vue&type=style&index=0&id=41e570da&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e570da",
  null
  
)

export default component.exports